<script setup lang="ts">
import { CatalogPage } from '@/pages/catalog/index';
</script>

<template>
  <CatalogPage />
</template>
